import { ClientId } from '@sternum/web/features/client/models';
import { EntityType } from '@sternum/web/types/apiTypes';

export interface TraceDefinition {
  id: string;
  name: string; // display_name
  type: string; // trace_event_name
  category: TraceCategory; // 'CRYPTO_EVENT';
  interest: EventInterest;
  transmitFrequency: TransmitFrequency; // 'BATCH'
  // deviceDefinitionId: DeviceDefinitionId;
  usage: number;

  // entityId: TraceDefinitionId;
  // entityType: EntityType; // 'TRACE_DEFINITION';
  // clientId: ClientId;
  // created: Date;
  // dataSource: string[]; // ["MySQL"]
  // isDeleted?: boolean;
  // description?: string;
  // deviceDefinitionVersion: DeviceDefinitionVersion;
  // isDisplayedInUi: boolean;
  // displayName: string;
  // eventInterest: EventInterest;
  // traceCategory: TraceCategory; // 'CRYPTO_EVENT';
  // traceEventName: string; // 'TRACE_ENCRYPT';
  // traceType: TraceType;
  // updated: string;
}

export interface TraceDefinitionApi {
  entity_id: string;
  entity_type: EntityType; // 'TRACE_DEFINITION';
  client: { is_reference: boolean; entity_id: ClientId };
  created: string;
  data_source: string[]; // ["MySQL"]
  deleted?: boolean | null;
  description?: string | null;
  device_definition_id: string;
  display_in_ui: boolean;
  display_name: string; // 'Encrypt';
  event_interest: EventInterest;
  trace_category: TraceCategory; // 'CRYPTO_EVENT';
  trace_event_name: string; // 'TRACE_ENCRYPT';
  trace_type: TraceType; // 'SYSTEM';
  transmit_frequency: TransmitFrequency; // 'BATCH';
  updated: string;
}

export enum EventInterest {
  High = 'HIGH',
  Medium = 'MEDIUM',
  Low = 'LOW',
  Regular = 'REGULAR',
}

export enum TraceCategory {
  SecurityEvent = 'SECURITY_EVENT',
  FileEvent = 'FILE_EVENT',
  CommunicationEvent = 'COMMUNICATION_EVENT',
  CryptoEvent = 'CRYPTO_EVENT',
  OsEvent = 'OS_EVENT',
  UpdateEvent = 'UPDATE_EVENT',
  AuthenticationEvent = 'AUTHENTICATION_EVENT',
  DiagnosticsEvent = 'DIAGNOSTICS_EVENT',
  CriticalEvent = 'CRITICAL_EVENT',
  RegulationAndQualityEvent = 'REGULATION_AND_QUALITY_EVENT',
  OperationsEvent = 'OPERATIONS_EVENT',
  UserActivityEvent = 'USER_ACTIVITY_EVENT',
}

export enum TraceType {
  System = 'SYSTEM',
}

export enum TransmitFrequency {
  Batch = 'BATCH',
}
